import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ClerkLoginModal } from '../clerk-login-modal/clerk-login-modal';
import { ClerkSignUpModal } from '../clerk-signup-modal/clerk-signup-modal';
import { ClerkAuthService } from '../services/clerk.service';

@Component({
  selector: 'pm-clerk-test',
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>Clerk Login Test</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div style="text-align: center; margin-top: 50px;">
        <h2>Clerk Authentication Test Page</h2>
        <p>Click the button below to test the Clerk login modal</p>
        <ion-button (click)="openClerkLogin()" size="large" style="margin-top: 30px;">
          Test Clerk Login
        </ion-button>
        
        <ion-button (click)="openClerkSignUp()" size="large" color="secondary" style="margin-top: 20px;">
          Test Clerk Sign Up
        </ion-button>
        
        <ion-button (click)="signOut()" size="large" color="danger" style="margin-top: 20px;">
          Sign Out / Clear Session
        </ion-button>
        
        <div style="margin-top: 30px;" *ngIf="currentUser">
          <h3>Current User:</h3>
          <p>{{ currentUser | json }}</p>
        </div>
        
        <div style="margin-top: 30px;" *ngIf="currentSession">
          <h3>Current Session:</h3>
          <p>{{ currentSession | json }}</p>
        </div>
      </div>
    </ion-content>
  `,
})
export class ClerkTestPage implements OnInit {
  currentUser: any = null;
  currentSession: any = null;

  constructor(
    private modalCtrl: ModalController,
    private clerkAuth: ClerkAuthService
  ) {}

  ngOnInit() {
    // Subscribe to user and session changes
    this.clerkAuth.user$.subscribe(user => {
      this.currentUser = user;
    });
    
    this.clerkAuth.session$.subscribe(session => {
      this.currentSession = session;
    });
  }

  async openClerkLogin() {
    const modal = await this.modalCtrl.create({
      component: ClerkLoginModal,
    });
    await modal.present();
  }
  
  async openClerkSignUp() {
    const modal = await this.modalCtrl.create({
      component: ClerkSignUpModal,
    });
    await modal.present();
  }
  
  async signOut() {
    try {
      await this.clerkAuth.signOut();
      console.log('Successfully signed out from Clerk');
      alert('Signed out successfully!');
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Error signing out. Check console for details.');
    }
  }
}